module.exports = __webpack_public_path__ + "img/your-events.0b526850.svg";